import { Action } from '@ngrx/store';
import * as dataRequest from '@models/request.model'

export const SETCREDENCIALREQUEST = '[startData] Set credencialRequestForm';
export const UNSETCREDENCIALREQUEST = '[startData] Unset credencialRequestForm';

export const SETCODIGODESEGURIDADREQUEST = '[startData] Set CODIGODESEGURIDADRequestForm';
export const UNSETCODIGODESEGURIDADREQUEST = '[startData] Unset cODIGODESEGURIDADRequestForm';

export const SETFINANCIADORREQUEST = '[startData] Set financiador';
export const UNSETFINANCIADORREQUEST = '[startData] Unset financiador';

export const SETPRESTADORREQUEST = '[startData] Set prestador';
export const UNSETPRESTADORREQUEST = '[startData] Unset prestador';

export const SETTRANSACCIONREQUEST = '[startData] Set transaccion';
export const UNSETTRANSACCIONREQUEST = '[startData] Unset trasaccion';

export const SETPRESCRIPCIONDISPENSAREQUEST = '[startData] Set prestacion dispensa';
export const UNSETPRESCRIPCIONDISPENSAREQUEST = '[startData] Unset prestacion dispensa';

export const SETAFILIADOREQUEST = '[startData] Set afiliado';
export const UNSETAFILIADOREQUEST = '[startData] Unset afiliado';

export const SETPATIENTREQUEST = '[startData] Set patient';
export const UNSETPATIENTREQUEST = '[startData] Unset patient';

export const UNSETDATOS = '[startData] Unset datos';

export class setCredencialRequest implements Action {
    readonly type = SETCREDENCIALREQUEST;
    constructor(
        public CredencialRequest: dataRequest.CredencialRequestModel
    ) { }
}

export class unsetCredencialRequest implements Action {
    readonly type = UNSETCREDENCIALREQUEST;
}

export class setCodigoDeSeguridadRequest implements Action {
    readonly type = SETCODIGODESEGURIDADREQUEST;
    constructor(
        public CodigoDeSeguridadRequest: string
    ) { }
}

export class unsetCodigoDeSeguridadRequest implements Action {
    readonly type = UNSETCODIGODESEGURIDADREQUEST;
}
export class setFinanciadorRequest implements Action {
    readonly type = SETFINANCIADORREQUEST;
    constructor(
        public FinanciadorRequest: dataRequest.FinanciadorRequestModel
    ) { }
}

export class unsetFinanciadorRequest implements Action {
    readonly type = UNSETFINANCIADORREQUEST;
}

export class setPrestadorRequest implements Action {
    readonly type = SETPRESTADORREQUEST;
    constructor(
        public PrestadorRequest: dataRequest.PrestadorRequestModel
    ) { }
}

export class unsetPrestadorRequest implements Action {
    readonly type = UNSETPRESTADORREQUEST;
}

export class setTransaccionRequest implements Action {
    readonly type = SETTRANSACCIONREQUEST;
    constructor(
        public TransaccionRequest: dataRequest.TransaccionRequestModel
    ) { }
}

export class unsetTransaccioRequest implements Action {
    readonly type = UNSETTRANSACCIONREQUEST;
}

export class setAfiliadoRequest implements Action {
    readonly type = SETAFILIADOREQUEST;
    constructor(
        public AfiliadoRequest: dataRequest.AfiliadoRequestModel
    ) { }
}

export class unsetAfiliadoRequest implements Action {
    readonly type = UNSETAFILIADOREQUEST;
}

export class setPatientRequest implements Action {
    readonly type = SETPATIENTREQUEST;
    constructor(
        public PatientRequest: any
    ) { }
}

export class unsetPatientRequest implements Action {
    readonly type = UNSETPATIENTREQUEST;
}

export class unsetDatosInicio implements Action {
    readonly type = UNSETDATOS;
}

export type startDataActions =
    | setCredencialRequest
    | unsetCredencialRequest
    | setCodigoDeSeguridadRequest
    | unsetCodigoDeSeguridadRequest
    | setFinanciadorRequest
    | unsetFinanciadorRequest
    | setPrestadorRequest
    | unsetPrestadorRequest
    | setTransaccionRequest
    | unsetTransaccioRequest
    | unsetDatosInicio
    | setAfiliadoRequest
    | unsetAfiliadoRequest
    | setPatientRequest
    | unsetPatientRequest;
